<template>
  <div class="relative isolate overflow-hidden bg-white">
    <svg
      class="absolute inset-0 -z-10 size-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
      aria-hidden="true"
    >
      <defs>
        <pattern
          id="983e3e4c-de6d-4c3f-8d64-b9761d1534cc"
          width="200"
          height="200"
          x="50%"
          y="-1"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M.5 200V.5H200"
            fill="none"
          />
        </pattern>
      </defs>
      <svg
        x="50%"
        y="-1"
        class="overflow-visible fill-gray-50"
      >
        <path
          d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z"
          stroke-width="0"
        />
      </svg>
      <rect
        width="100%"
        height="100%"
        stroke-width="0"
        fill="url(#983e3e4c-de6d-4c3f-8d64-b9761d1534cc)"
      />
    </svg>
    <div
      class="absolute left-[calc(50%-4rem)] top-10 -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)]"
      aria-hidden="true"
    >
      <div
        class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-indigo-300 to-indigo-500 opacity-20"
        style="
                    clip-path: polygon(
                        73.6% 51.7%,
                        91.7% 11.8%,
                        100% 46.4%,
                        97.4% 82.2%,
                        92.5% 84.9%,
                        75.7% 64%,
                        55.3% 47.5%,
                        46.5% 49.4%,
                        45% 62.9%,
                        50.3% 87.2%,
                        21.3% 64.1%,
                        0.1% 100%,
                        5.4% 51.1%,
                        21.4% 63.9%,
                        58.9% 0.2%,
                        73.6% 51.7%
                    );
                "
      />
    </div>
    <div class="mx-auto max-w-7xl py-16 px-4 lg:flex sm:px-6 lg:px-8">
      <div class="mx-auto max-w-2xl shrink-0 lg:mx-0 lg:pt-8">
        <h1
          class="mt-10 text-pretty text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl"
        >
          The fast and easy way to create postcards
        </h1>
        <p
          class="mt-8 text-pretty text-lg font-medium text-gray-600 sm:text-xl/8"
        >
          Effortlessly design stunning postcards and receive clean
          HTML code instantly with our advanced features.
        </p>
        <div
          class="mt-10 flex flex-col sm:flex-row items-center gap-4 sm:gap-x-6"
        >
          <Link
            :href="route('login')"
            class="w-full sm:w-fit"
          >
            <Button class="w-full">
              Get started
            </Button>
          </Link>
          <!-- <Button
            href="#"
            variant="outline"
            class="w-full sm:w-auto text-sm/6 font-semibold text-center px-4"
            size="lg"
          >
            Learn more
          </Button> -->
        </div>
      </div>
      <div
        class="mx-auto mt-16 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32"
      >
        <div class="max-w-3xl flex-none sm:max-w-5xl lg:max-w-none">
          <img
            :src="AppScreenshot"
            alt="App screenshot"
            width="2432"
            height="811"
            class="w-[50rem] rounded-md bg-gray-50 shadow-xl ring-1 ring-gray-200"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { route } from "ziggy-js";
import { Link } from "@inertiajs/vue3";
import Button from "@/Components/ui/button/Button.vue";
import AppScreenshot from "../../../images/app-screenshot.png";
</script>
